import PixallPreload from './PixallPreload';

export default PixallPreload;
